export default "__VITE_ASSET__jTR0w7Ck__"